import React from 'react';
import ReactDOM from 'react-dom';
import OralSimulationApp from './components/OralSimulationApp';

import * as serviceWorker from './serviceWorker';

// import 'bootstrap/dist/css/bootstrap.min.css';



let render = function(simulation = 1){
    ReactDOM.render(<OralSimulationApp simulation={simulation}/>, document.getElementById('tf-oral-simulation-public-app'));
};

if(typeof window.apps === 'undefined'){
    window.apps = {};
}
window.apps.oralSimulationPublicApp = render;
// window.apps.oralSimulationPublicApp();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
